<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load account history"
    data-testid="warrants-account-history"
    :fetcher="fetchHistory"
    :items-from="itemsFrom"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip :text="internalItem.raw.statusDisplay" size="small" />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"
  import {
    createdAtColumn,
    deletedColumn,
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsAccountHistoryListResult,
    WarrantsAccountHistoryService,
  } from "@/services/admin/WarrantsAccountHistoryService"

  const headers: SoDataTableHeader[] = [
    idColumn,
    statusColumn,
    {
      title: "Current Status",
      key: "currentStatusDisplay",
      sortable: true,
      sortKey: "current_status",
    },
    {
      title: "Next Status",
      key: "nextStatusDisplay",
      sortable: true,
      sortKey: "next_status",
    },
    {
      title: "Message",
      key: "message",
      sortable: false,
      fallbackValue: "—",
    },
    createdAtColumn,
    {
      title: "Updated At",
      key: "updatedAt",
      type: SoDataTableColumnType.DATE_TIME,
      sortable: true,
      sortKey: "updated_at",
    },
    deletedColumn,
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
      }
    },
    computed: {
      accountNumber(): string {
        return this.$route.params.accountNumber as string
      },
    },
    methods: {
      fetchHistory({ page, pageSize, orderBy }: SoDataTableOptions) {
        return WarrantsAccountHistoryService.getHistory(
          this.accountNumber,
          page,
          pageSize,
          orderBy,
        )
      },
      itemsFrom(result: WarrantsAccountHistoryListResult) {
        return result.history
      },
    },
  })
</script>
